<template>
  <div class="login-warp">
    <div class="title-text"><span><b>元素网管理平台登录入口</b></span></div>
    <div class="login-auto">
      <el-input placeholder="请输入用户名" v-model="username">
        <template slot="prepend">用户</template>
      </el-input>
      <el-input type="password" style="margin-top: 10px" placeholder="请输入密码" v-model="password">
        <template slot="prepend">密码</template>
      </el-input>
      <div style="width: 100%;margin-top: 20px">
        <el-button :loading="loading" style="float: right" type="primary" @click="login">登录</el-button>
      </div>

    </div>
  </div>

</template>
<script>
  import axios from 'axios'

  export default {
    data() {
      return {
        username: '',
        password: '',
        loading: false
      }
    }
    , methods: {
      async login() {
        this.loading = true
        let r = await axios.post('/admin/login', {
          username: this.username,
          password: this.password
        })
        if (r.code == 1001) {
          this.$message.error('用户名或密码不能为空')
        }else if (r.code == 0) {
          this.$router.push('/')
        }else {
          this.$message.error('用户名或者密码不正确')
        }
        this.loading = false
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .login-warp {
    width: 100%;
    height: 20px;
    margin-top: 220px
  }

  .login-auto {
    padding: 20px;
    width: 300px;
    height: 140px;
    margin: 0 auto;
    background: white;
  }

  .title-text {
    width: 300px;
    margin: 0 auto;
    text-align: center;
    font-weight: 700;
    color: #444;
    font-size: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/main/system/Login.vue